// import React from "react";
// import { Box, Typography, Container, Grid, IconButton, Stack, Divider, Button } from "@mui/material";
// import { Link as ScrollLink } from "react-scroll";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

// const Footer = () => {
//   const primarySaffron = "#FF8C00"; // Vibrant Saffron
//   const deepGolden = "#B8860B"; // Dark Gold
//   const darkBg = "#1A1A1A"; // Deep Charcoal Black

//   const quickLinks = [
//     { label: "मुख्य", to: "home" },
//     { label: "आमच्या विषयी", to: "about" },
//     { label: "सेवा", to: "services" },
//     { label: "संगीत संग्रह", to: "music" },
//     { label: "उत्पादने", to: "products" },
//     { label: "संपर्क", to: "contact" },
//   ];

//   const services = ["जैन संगीत संग्रह", "पूजा विधान मार्गदर्शन", "कराओके ट्रॅक", "विधान पुस्तके", "पूजा साहित्य", "मंत्रोच्चार प्रशिक्षण"];

//   return (
//     <Box sx={{ bgcolor: darkBg, color: "#fff", pt: 8, pb: 4, mt: 0 }}>
//       <Container maxWidth="lg">
//         <Grid container spacing={6} justifyContent="center">
          
//           {/* --- १. ब्रँड आणि माहिती --- */}
//           <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
//             <Stack direction="row" spacing={2} alignItems="center" justifyContent={{ xs: 'center', md: 'flex-start' }} sx={{ mb: 2 }}>
//               <Box sx={{ 
//                 width: 45, height: 45, borderRadius: "50%", 
//                 bgcolor: primarySaffron, display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 fontSize: '20px', fontWeight: 'bold', border: `2px solid ${deepGolden}`,
//                 boxShadow: `0 0 15px ${primarySaffron}44`
//               }}>ॐ</Box>
//               <Box>
//                 <Typography variant="h5" sx={{ fontWeight: 900, color: '#fff', letterSpacing: 1 }}>जिन भक्ती</Typography>
//                 <Typography variant="caption" sx={{ color: primarySaffron, fontWeight: 700 }}>जिनभक्ती स्वर संगीत ग्रुप</Typography>
//               </Box>
//             </Stack>
//             <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.8, mb: 3 }}>
//               दिगंबर जैन धर्मातील भक्ती संगीत आणि पूजा विधानांचे जतन व प्रसार करण्यासाठी समर्पित व्यासपीठ.
//             </Typography>
            
//             {/* सोशियल आयकॉन्स */}
//             <Stack direction="row" spacing={1.5} justifyContent={{ xs: 'center', md: 'flex-start' }}>
//               {[<FacebookIcon />, <InstagramIcon />, <YouTubeIcon />, <WhatsAppIcon />].map((icon, index) => (
//                 <IconButton key={index} sx={{ 
//                   color: 'rgba(255,255,255,0.6)', 
//                   border: '1px solid rgba(255,255,255,0.1)',
//                   transition: 'all 0.3s ease',
//                   '&:hover': { 
//                     bgcolor: primarySaffron, 
//                     color: '#fff',
//                     transform: 'translateY(-5px)',
//                     boxShadow: `0 5px 15px ${primarySaffron}66`
//                   }
//                 }}>
//                   {icon}
//                 </IconButton>
//               ))}
//             </Stack>
//           </Grid>

//           {/* --- २. द्रुत दुवे --- */}
//           <Grid item xs={6} md={2} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
//             <Typography variant="h6" sx={{ fontWeight: 800, mb: 3, color: primarySaffron }}>दुवे</Typography>
//             <Stack spacing={1.5}>
//               {quickLinks.map((link, i) => (
//                 <ScrollLink key={i} to={link.to} smooth={true} duration={500} style={{ textDecoration: 'none' }}>
//                   <Typography sx={{ 
//                     cursor: 'pointer', 
//                     color: 'rgba(255,255,255,0.7)', 
//                     fontSize: '14px',
//                     transition: 'all 0.3s ease',
//                     display: 'inline-block',
//                     '&:hover': { 
//                       color: primarySaffron,
//                       transform: 'translateX(8px)',
//                       fontWeight: 'bold'
//                     }
//                   }}>
//                     {link.label}
//                   </Typography>
//                 </ScrollLink>
//               ))}
//             </Stack>
//           </Grid>

//           {/* --- ३. सेवा --- */}
//           <Grid item xs={6} md={3} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
//             <Typography variant="h6" sx={{ fontWeight: 800, mb: 3, color: primarySaffron }}>आमच्या सेवा</Typography>
//             <Stack spacing={1.5}>
//               {services.map((s, i) => (
//                 <Typography key={i} variant="body2" sx={{ 
//                   color: 'rgba(255,255,255,0.7)',
//                   transition: 'color 0.3s ease',
//                   cursor: 'default',
//                   '&:hover': { color: deepGolden }
//                 }}>{s}</Typography>
//               ))}
//             </Stack>
//           </Grid>

//           {/* --- ४. संपर्क आणि Admin Login --- */}
//           <Grid item xs={12} md={3} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
//             <Typography variant="h6" sx={{ fontWeight: 800, mb: 3, color: primarySaffron }}>संपर्क</Typography>
//             <Box sx={{ mb: 2, transition: 'transform 0.3s ease', '&:hover': { transform: 'scale(1.02)' } }}>
//               <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', display: 'block' }}>प्र.पं. श्री दीपक उपाध्ये</Typography>
//               <Typography variant="body1" sx={{ fontWeight: 700, color: deepGolden }}>+91 9561339050</Typography>
//             </Box>
//             <Box sx={{ mb: 3, transition: 'transform 0.3s ease', '&:hover': { transform: 'scale(1.02)' } }}>
//               <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', display: 'block' }}>पं. श्री.अभयकुमार उपाध्ये</Typography>
//               <Typography variant="body1" sx={{ fontWeight: 700, color: deepGolden }}>+91 9822339632</Typography>
//             </Box>
            
//             {/* Admin Login Button with Link */}
//             <Button 
//               variant="outlined" 
//               startIcon={<AdminPanelSettingsIcon />}
//               component="a" // लिंक म्हणून काम करण्यासाठी
//               href="https://jinbhaktifrontend.jinbhakti.in/" // इथे तुमची ॲडमिन पॅनेलची लिंक टाका
//               sx={{ 
//                 borderColor: primarySaffron, color: primarySaffron, borderRadius: '20px', textTransform: 'none',
//                 transition: 'all 0.3s ease',
//                 '&:hover': { 
//                   bgcolor: primarySaffron, 
//                   color: '#fff', 
//                   borderColor: primarySaffron,
//                   boxShadow: `0 4px 12px ${primarySaffron}44`
//                 }
//               }}
//             >
//               Admin Login
//             </Button>
//           </Grid>

//         </Grid>

//         <Divider sx={{ my: 6, borderColor: 'rgba(255,255,255,0.08)' }} />

//         {/* --- कॉपीराईट विभाग --- */}
//         <Box sx={{ textAlign: 'center' }}>
//           <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', mb: 1 }}>
//             © 2026 <strong>जिन भक्ती</strong>. सर्व हक्क राखीव.
//           </Typography>
//           <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)', letterSpacing: 0.5 }}>
//             Designed and developed by <span style={{ color: primarySaffron, fontWeight: 'bold' }}>Comtranse Technology</span>, Kolhapur.
//           </Typography>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default Footer;  
import React from "react";
import { Box, Typography, Container, Grid, IconButton, Stack, Divider, Button, Tooltip } from "@mui/material";
import { Link as ScrollLink } from "react-scroll";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import DownloadIcon from "@mui/icons-material/GetApp"; 
import AppIcon from "@mui/icons-material/ShopTwo"; 
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

const Footer = () => {
  const primarySaffron = "#FF8C00"; 
  const deepGolden = "#B8860B"; 
  const darkBg = "#1A1A1A"; 
  const apkDownloadPath = "/apk/JinbhaktiApp(09-06-2026).apk"; 

  const quickLinks = [
    { label: "मुख्य", to: "home" },
    { label: "आमच्या विषयी", to: "about" },
    { label: "सेवा", to: "services" },
    { label: "संगीत संग्रह", to: "music" },
    { label: "उत्पादने", to: "products" },
    { label: "संपर्क", to: "contact" },
  ];

  const services = ["जैन संगीत संग्रह", "पूजा विधान मार्गदर्शन", "कराओके ट्रॅक", "विधान पुस्तके", "पूजा साहित्य", "मंत्रोच्चार प्रशिक्षण"];

  const socialAndDownloadLinks = [
    { label: "Facebook", icon: <FacebookIcon />, type: "external", url: "#" },
    { label: "Instagram", icon: <InstagramIcon />, type: "external", url: "#" },
    { label: "YouTube", icon: <YouTubeIcon />, type: "external", url: "#" },
    { label: "WhatsApp", icon: <WhatsAppIcon />, type: "external", url: "#" },
    { label: "Download APK", icon: <DownloadIcon />, type: "download", url: apkDownloadPath } 
  ];

  return (
    <Box sx={{ bgcolor: darkBg, color: "#fff", pt: 8, pb: 4, mt: 0 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="center">
          
          {/* --- १. ब्रँड आणि माहिती --- */}
          <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent={{ xs: 'center', md: 'flex-start' }} sx={{ mb: 2 }}>
              <Box sx={{ 
                width: 45, height: 45, borderRadius: "50%", 
                bgcolor: primarySaffron, display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '20px', fontWeight: 'bold', border: `2px solid ${deepGolden}`,
                boxShadow: `0 0 15px ${primarySaffron}44`
              }}>ॐ</Box>
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 900, color: '#fff', letterSpacing: 1 }}>जिन भक्ती</Typography>
                <Typography variant="caption" sx={{ color: primarySaffron, fontWeight: 700 }}>जिनभक्ती स्वर संगीत ग्रुप</Typography>
              </Box>
            </Stack>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.8, mb: 3 }}>
              दिगंबर जैन धर्मातील भक्ती संगीत आणि पूजा विधानांचे जतन व प्रसार करण्यासाठी समर्पित व्यासपीठ.
            </Typography>
            
            <Stack direction="row" spacing={1.5} justifyContent={{ xs: 'center', md: 'flex-start' }}>
              {socialAndDownloadLinks.map((item, index) => (
                <Tooltip key={index} title={item.label} arrow placement="top">
                  <IconButton 
                    component="a"
                    href={item.url}
                    {...(item.type === "download" ? { download: "JinbhaktiApp.apk" } : {})} 
                    sx={{ 
                      color: 'rgba(255,255,255,0.6)', 
                      border: '1px solid rgba(255,255,255,0.1)',
                      transition: 'all 0.3s ease',
                      '&:hover': { 
                        bgcolor: primarySaffron, 
                        color: '#fff',
                        transform: 'translateY(-5px)',
                        boxShadow: `0 5px 15px ${primarySaffron}66`
                      }
                    }}
                  >
                    {item.icon}
                  </IconButton>
                </Tooltip>
              ))}
            </Stack>
          </Grid>

          {/* --- २. द्रुत दुवे --- */}
          <Grid item xs={6} md={2} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 3, color: primarySaffron }}>दुवे</Typography>
            <Stack spacing={1.5}>
              {quickLinks.map((link, i) => (
                <ScrollLink key={i} to={link.to} smooth={true} duration={500} style={{ textDecoration: 'none' }}>
                  <Typography sx={{ 
                    cursor: 'pointer', 
                    color: 'rgba(255,255,255,0.7)', 
                    fontSize: '14px',
                    transition: 'all 0.3s ease',
                    display: 'inline-block',
                    '&:hover': { 
                      color: primarySaffron,
                      transform: 'translateX(8px)',
                      fontWeight: 'bold'
                    }
                  }}>
                    {link.label}
                  </Typography>
                </ScrollLink>
              ))}
            </Stack>
          </Grid>

          {/* --- ३. सेवा --- */}
          <Grid item xs={6} md={3} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 3, color: primarySaffron }}>आमच्या सेवा</Typography>
            <Stack spacing={1.5}>
              {services.map((s, i) => (
                <Typography key={i} variant="body2" sx={{ 
                  color: 'rgba(255,255,255,0.7)',
                  transition: 'color 0.3s ease',
                  cursor: 'default',
                  '&:hover': { color: deepGolden }
                }}>{s}</Typography>
              ))}
            </Stack>
          </Grid>

          {/* --- ४. संपर्क आणि फिक्स केलेला बटन्स विभाग --- */}
          <Grid item xs={12} md={3} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 3, color: primarySaffron }}>संपर्क</Typography>
            
            <Box sx={{ mb: 2 }}>
              <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', display: 'block' }}>प्र.पं. श्री दीपक उपाध्ये</Typography>
              <Typography variant="body1" sx={{ fontWeight: 700, color: deepGolden }}>+91 9561339050</Typography>
            </Box>
            
            <Box sx={{ mb: 3 }}>
              <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', display: 'block' }}>पं. श्री.अभयकुमार उपाध्ये</Typography>
              <Typography variant="body1" sx={{ fontWeight: 700, color: deepGolden }}>+91 9822339632</Typography>
            </Box>
            
            {/* बटन्सची जागा हलणार नाही यासाठी हा स्पेशल बॉक्स कंटेनर */}
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: { xs: 'center', md: 'flex-start' }, 
              gap: 2,
              mt: 2,
              width: '100%'
            }}>
              
              {/* --- Download App बटण --- */}
              <Button
                component="a"
                href={apkDownloadPath}
                download="JinbhaktiApp.apk"
                variant="contained"
                startIcon={<AppIcon />}
                sx={{
                  bgcolor: '#fff',
                  color: '#FF8C00',
                  fontWeight: 800,
                  borderRadius: '30px', 
                  py: 1,
                  px: 2.5,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                  width: { xs: '200px', md: '100%' }, // विड्थ कमी केली जेणेकरून लेआउट व्यवस्थित बसेल
                  boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
                  fontSize: '0.95rem',
                  '&:hover': {
                    bgcolor: '#fff',
                    boxShadow: '0px 6px 15px rgba(0,0,0,0.35)',
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                Download App
              </Button>
              
              {/* --- Admin Login बटण --- */}
              <Button 
                variant="outlined" 
                startIcon={<AdminPanelSettingsIcon />}
                component="a" 
                href="https://jinbhaktifrontend.jinbhakti.in/" 
                sx={{ 
                  borderColor: primarySaffron, 
                  color: primarySaffron, 
                  borderRadius: '30px', 
                  fontWeight: 700,
                  py: 1,
                  px: 2.5,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                  width: { xs: '200px', md: '100%' }, // दोन्ही बटन्स एकाच मापाचे राहतील
                  fontSize: '0.95rem',
                  transition: 'all 0.2s ease',
                  '&:hover': { 
                    bgcolor: primarySaffron, 
                    color: '#fff', 
                    borderColor: primarySaffron,
                    boxShadow: `0 4px 12px ${primarySaffron}33`,
                    transform: 'translateY(-1px)'
                  }
                }}
              >
                Admin Login
              </Button>
            </Box>
          </Grid>

        </Grid>

        <Divider sx={{ my: 5, borderColor: 'rgba(255,255,255,0.08)' }} />

        {/* --- कॉपीराईट विभाग --- */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', mb: 1 }}>
            © 2026 <strong>जिन भक्ती</strong>. सर्व हक्क राखीव.
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)', letterSpacing: 0.5 }}>
            Designed and developed by <span style={{ color: primarySaffron, fontWeight: 'bold' }}>Comtranse Technology</span>, Kolhapur.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;